<template>
  <div class="ipt-wrap" :class="hasError ? 'has-error-wrap' : ''" :style="{ width: width }">
    <div class="ipt-wrap-inner">
      <input class="base-input" :class="[hasError ? 'has-error' : '', blurClass]" :type="type" :value="value" @input="triggerInput" @blur="handleBlur" @focus="handleFocus" :placeholder="placeholder" :autofocus="autofocus" :maxlength="limitLength" v-if="isLimitLength">
      <input class="base-input" :class="[hasError ? 'has-error' : '', blurClass]" :type="type" :value="value" @input="triggerInput" @blur="handleBlur" @focus="handleFocus" :placeholder="placeholder" :autofocus="autofocus" v-else>
      <label class="placeholder">{{ placeholder }}</label>
      <slot/>
    </div>
    <span class="err" v-if="hasError">{{ errorMsg }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      blurClass: ''
    }
  },

  props: {
    placeholder: {
      type: String,
      default: '请输入'
    },
    value: {
      type: String,
      default: ''
    },
    isLimitLength: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    limitLength: {
      type: Number,
      default: 15
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: '出错啦！'
    },
    type: {
      type: String,
      default: 'text'
    },
    isNumber: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    triggerInput(e) {
      let value = e.target.value;
      if (this.isNumber) {
        value = value.replace(/[^\d]/g, '');
      }
      this.$emit('input', value);
      this.$nextTick(() => {
        if (this.isNumber) {
          e.target.value = value;
        }
      })
      // if (this.isLimitLength) {
      //   // 长度限制
      //   const len = this.limitLength;
      //   if (value.length > len) {
      //     const val = value.slice(0, len);
      //     this.$emit('input', val);
      //     e.target.value = val;
      //   } else {
      //     this.$emit('input', value);
      //     if (this.isNumber) {
      //       e.target.value = value;
      //     }
      //   }
      // } else {
      //   this.$emit('input', value);
      // if (this.isNumber) {
      //   e.target.value = value;
      // }
      // }
    },

    handleFocus() {
      this.blurClass = '';
      this.$emit('ipt-focus');
    },

    handleBlur() {
      if (this.value !== '') {
        this.blurClass = 'blur';
      }
      this.$emit('ipt-blur');
    }
  }
};
</script>

<style lang="scss" scoped>
.ipt-wrap {
  position: relative;
  width: 100%;
  min-width: 150px;
  font-size: 14px;

  &.has-error-wrap {
    margin-bottom: 34px !important;
  }

  &-inner {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    .base-input {
      width: 100%;
      padding: 13.5px 10px;
      outline: none;
      font-weight: 500;
      background: #FFFFFF;
      color: #333333;
      border: 1px solid #DDDDDD;
      border-radius: 4px;
      transition: all .25s;
      font-size: 14px;

      &:placeholder-shown::placeholder {
        color: transparent;
      }

      &:focus,
      &:not(:placeholder-shown) {
        border: 1px solid #08A681;

        & + .placeholder {
          font-size: 12px;
          color: #08A681;
          font-weight: bolder;
          letter-spacing: 0;
          line-height: 16px;
          transform: translate(-2px, -22px);
        }
      }

      &.blur {
        border: 1px solid #DDDDDD;

        & + .placeholder {
          color: #666;
          font-weight: lighter;
        }      
      }

      &.has-error {
        border: 1px solid #E51C23;

        & + .placeholder {
          color: #666;
        }
      }
    }

    .placeholder {
      position: absolute;
      left: 11px;
      top: 50%;
      padding: 0 2px;
      margin-top: -7px;
      transform-origin: 0 0;
      background: #fff;
      color: #999;
      transition: all .25s;
      pointer-events: none;
    }
  }

  .err {
    position: absolute;
    left: 11px;
    bottom: -23px;
    font-size: 12px;
    font-weight: bolder;
    color: #E51C23;
    letter-spacing: 0;
    line-height: 16px;
  }
}
</style>
